export default __webpack_public_path__ + "3400fedd134e0ce59668ca2d2c273aa8.png";